export default __webpack_public_path__ + "static/media/img-0295-zambia-half-face.b4056794.png";